export const checkSearchString = (text: string, search: string): boolean => {
  return !!text && text.toLowerCase().indexOf(search) !== -1;
};
